export const FIREBASE_PUBLIC_CONFIG = {
  apiKey: 'AIzaSyDIT-S2lVrbp-buJTmCNMFlQFNhMpwu7TM',
  authDomain: 'cuidarte-app.firebaseapp.com',
  databaseURL: 'https://cuidarte-app.firebaseio.com',
  projectId: 'cuidarte-app',
  storageBucket: 'cuidarte-app.appspot.com',
  messagingSenderId: '639204825985',
  appId: '1:639204825985:web:b4d907494cf49e2f81e680',
  measurementId: 'G-YXJ6904K5B',
}
